module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAQlBMVEUAAABWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/SadqbHAAAAFXRSTlMA9kSYFd9eJ/2C6p0FctFpM76weMPPXKm6AAAAcUlEQVQY02XOWQ7AIAhFUa1T0FY7sf+tlmgCaO/nCQnPjDwExGszupSx55TtdDY6BCNyO2MRPBlvQfkFgl6es71s6jQZ1dEpdJN8hGebBapFylbwsl0VhzWcatMevcCt6AjzipkQfxHa1SxhKkFTKMl8tsgSXo5YXcwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_mine_s.png
// module id = EXKf
// module chunks = 16